import React from 'react';

export function CampaignEmailCopyrightFooter() {
  const year = new Date().getFullYear();
  return (
    <div className="mt-3 px-4 pb-1 text-center text-[11px] leading-relaxed text-muted-foreground">
      <p className="m-0 font-medium text-foreground">© deepblock {year}</p>
    </div>
  );
}

export default function CampaignEmailLegalFooter({
  recipientEmail = 'email du destinataire',
}) {
  return (
    <div className="border-t border-border/40 px-4 py-3 text-center text-[11px] leading-relaxed text-muted-foreground">
      <p className="m-0">
        Ce courriel a été envoyé à
        <br />
        <span className="font-medium">« {recipientEmail || 'email du destinataire'} »</span>
      </p>
      <a
        href="https://www.deepblock.eu/mentions-legales"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-1 inline-block text-muted-foreground no-underline hover:text-muted-foreground hover:no-underline"
      >
        Mentions légales
      </a>
    </div>
  );
}
